import React from "react";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

export type FieldingSlot = { pos: string; inn: number; g: number; gs: number; e: number };

/** Parse the `fielding` CSV column. Seasons built before it existed come back
 *  from /player/<id> as the number 0 (the endpoint fillna(0)s everything). */
export function parseFielding(raw: any): FieldingSlot[] {
  if (typeof raw !== "string") return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export default function FieldingTable({ fielding }: { fielding: any }) {
  const slots = parseFielding(fielding).filter((f) => Number(f.inn) > 0);
  if (slots.length === 0) return null;

  return (
    <div>
      <Typography variant="h5" style={{ fontSize: "20pt", marginLeft: "10px", marginTop: "20px" }}>
        Fielding
      </Typography>
      <TableContainer component={Paper}>
        <Table size="small" padding="none" sx={{ width: "95%", marginLeft: "10px", marginTop: "5px", marginBottom: "15px" }}>
          <TableHead>
            <TableRow>
              <TableCell>POS</TableCell>
              {slots.map((f) => (
                <TableCell key={f.pos}>{f.pos}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow key={"innings"}>
              <TableCell>INN</TableCell>
              {slots.map((f) => (
                <TableCell key={f.pos}>{Number(f.inn).toFixed(1)}</TableCell>
              ))}
            </TableRow>
            <TableRow key={"games"}>
              <TableCell>G</TableCell>
              {slots.map((f) => (
                <TableCell key={f.pos}>{f.g}</TableCell>
              ))}
            </TableRow>
            <TableRow key={"errors"}>
              <TableCell>E</TableCell>
              {slots.map((f) => (
                <TableCell key={f.pos}>{f.e}</TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
